module.exports = __webpack_public_path__ + "img/viewResume.98b12982.svg";